{
  "name": "rocos-console",
  "version": "1.1.0-b65a4f9",
  "browser": {
    "fs": false,
    "path": false,
    "os": false,
    "crypto": false
  },
  "engines": {
    "npm": ">=8.0.0",
    "node": ">=26.0.0"
  },
  "scripts": {
    "start": "npm run ng-high-memory -- serve --port=4200 --configuration=local",
    "playwright-inspector": "npx playwright codegen http://localhost:4200/account/6477a62337a71522a0381311/projects",
    "artifactregistry-login": "npx google-artifactregistry-auth",
    "---------  FOR CI ------------------": "true",
    "ng-high-memory": "node --max_old_space_size=6144 ./node_modules/@angular/cli/bin/ng",
    "build-feature": "npm run ng-high-memory -- build --configuration=development --output-path=dist/feature",
    "build-release-dev": "npm run ng-high-memory --  build --configuration=development --output-path=dist/release-dev",
    "build-release-stage": "npm run ng-high-memory --  build --configuration=staging --output-path=dist/release-stage",
    "build-release-prod": "npm run ng-high-memory --  build --configuration=production --output-path=dist/release",
    "test-headless": "ng test --source-map=false --watch=false --progress=false --browsers=ChromeHeadlessNoSandbox",
    "---------  We need these! ------------------": "true",
    "test": "ng test",
    "test-e2e": "playwright test",
    "test-e2e-dev": "playwright test --ui",
    "test-e2e-chrome": "playwright test --project chromium",
    "test-e2e-safari": "playwright test --project safari",
    "test-e2e-rc": "playwright test --project agent-rc",
    "test-headless-once": "ng test --source-map=false --watch=false --progress=false --browsers=ChromeHeadlessNoSandbox",
    "lint": "npm run ng-high-memory -- lint rocos-console --max-warnings 354",
    "icons": "fantasticon --config ./src/styles/icons/.fantasticonrc.js && mv ./src/styles/fonts/rocos-icon/rocos-icon.html ./src/styles/fonts/rocos-icon/index.html",
    "icons:preview": "npm run icons && npx serve ./src/styles/fonts/rocos-icon",
    "update:rocos-js": "npm install @team-rocos/rocos-js --no-save",
    "update:rocos-js:dev": "npm install @team-rocos/rocos-js@dev --no-save",
    "---------  these are nice... but? ----------": "true/false",
    "bundle:analyze": "npx webpack-bundle-analyzer ./dist/stats.json",
    "lint:report": "ng lint rocos-console --format html --output-file ./eslint-report.html",
    "build-prod-analyzer": "ng build --named-chunks --stats-json --output-path=dist",
    "docs": "npx @techdocs/cli serve",
    "---------  can-we-remove-the-scripts below?-----": "true/false",
    "prettier:fix": "npx prettier --write ./src/app './src/app/*.html'",
    "prepare": "husky install",
    "build": "ng build --output-path=dist --stats-json",
    "---------  these does not work -----------------": "true",
    "size": "size-limit"
  },
  "private": true,
  "dependencies": {
    "@amcharts/amcharts4": "^4.10.2",
    "@angular/animations": "^18.2.13",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.13",
    "@angular/compiler": "^18.2.13",
    "@angular/core": "^18.2.13",
    "@angular/elements": "^18.2.13",
    "@angular/forms": "^18.2.13",
    "@angular/material": "^18.2.14",
    "@angular/platform-browser": "^18.2.13",
    "@angular/platform-browser-dynamic": "^18.2.13",
    "@angular/router": "^18.2.13",
    "@babylonjs/core": "^6.3.1",
    "@babylonjs/gui": "^6.3.1",
    "@babylonjs/inspector": "^6.29.1",
    "@babylonjs/loaders": "^6.3.1",
    "@babylonjs/materials": "^6.3.1",
    "@datadog/browser-rum": "^6.6.3",
    "@deck.gl/core": "^8.2.8",
    "@deck.gl/layers": "^8.2.8",
    "@dronedeploy/rocos-js-sdk": "^4.4.3",
    "@loaders.gl/3d-tiles": "^3.4.4",
    "@loaders.gl/core": "^3.2.4",
    "@material/elevation": "^15.0.0-canary.bc9ae6c9c.0",
    "@math.gl/culling": "^3.6.0",
    "@math.gl/proj4": "^3.6.3",
    "@ngneat/transloco": "^4.0.0",
    "@ngneat/until-destroy": "^9.2.0",
    "@team-rocos/rocos-js": "^0.3.0-stable.79",
    "angular-gridster2": "^18.0.1",
    "angular-split": "^18.0.0",
    "angulartics2": "^14.1.0",
    "bootstrap": "^4.6.1",
    "cron-parser": "^4.7.0",
    "cronstrue": "^1.123.0",
    "d3-shape": "^3.1.0",
    "date-fns": "^3.6.0",
    "datemath-parser": "^1.0.6",
    "earcut": "^3.0.2",
    "esprima": "^4.0.1",
    "expr-eval": "^2.0.2",
    "file-saver": "^2.0.2",
    "filesize": "^10.0.7",
    "geojson": "^0.5.0",
    "graphology": "^0.25.4",
    "graphology-shortest-path": "^2.1.0",
    "grpc-web": "~1.1.0",
    "jszip": "^3.10.1",
    "launchdarkly-js-client-sdk": "^3.1.3",
    "lodash": "^4.17.21",
    "mapbox-gl": "^1.12.0",
    "mathjs": "^11.10.0",
    "ng-circle-progress": "^1.7.1",
    "papaparse": "^5.4.1",
    "parse-duration": "^0.4.4",
    "ramda": "^0.26.1",
    "rete": "^1.4.6-rc.1",
    "rete-area-plugin": "^0.2.1",
    "rete-auto-arrange-plugin": "^0.5.0-rc.1",
    "rete-connection-plugin": "^0.9.0",
    "rxjs": "^7.8.1",
    "semver": "^7.5.2",
    "static-eval": "^2.1.0",
    "ua-parser-js": "^1.0.33",
    "unquoted-property-validator": "^1.1.0",
    "xterm": "^4.11.0",
    "xterm-addon-fit": "^0.5.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/architect": "^0.1802.20",
    "@angular-devkit/build-angular": "^18.2.20",
    "@angular-eslint/builder": "^18.4.3",
    "@angular-eslint/eslint-plugin": "^18.4.3",
    "@angular-eslint/eslint-plugin-template": "^18.4.3",
    "@angular-eslint/schematics": "^18.4.3",
    "@angular-eslint/template-parser": "^18.4.3",
    "@angular/build": "^18.2.20",
    "@angular/cli": "^22.0.0",
    "@angular/compiler-cli": "^18.2.13",
    "@playwright/test": "^1.54.2",
    "@slack/types": "^2.16.0",
    "@types/esprima": "^4.0.2",
    "@types/file-saver": "^2.0.1",
    "@types/geojson": "^7946.0.4",
    "@types/jasmine": "~3.6.0",
    "@types/lodash": "^4.14.182",
    "@types/node": "18.16.16",
    "@types/papaparse": "^5.3.8",
    "@types/static-eval": "^0.2.30",
    "@types/ua-parser-js": "^0.7.36",
    "@types/url-parse": "^1.4.3",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "dotenv": "^16.1.4",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^8.5.0",
    "eslint-plugin-import": "2.26.0",
    "eslint-plugin-jsdoc": "^48.2.3",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "eslint-plugin-prettier": "^4.1.0",
    "eslint-plugin-sonarjs": "^0.18.0",
    "eslint-plugin-unicorn": "^45.0.2",
    "fantasticon": "^1.2.3",
    "husky": "^8.0.0",
    "jasmine-core": "^5.0.0",
    "jasmine-reporters": "^2.5.0",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.4.1",
    "karma-chrome-launcher": "^3.1.1",
    "karma-coverage": "^2.2.0",
    "karma-jasmine": "^5.0.0",
    "karma-jasmine-html-reporter": "^1.7.0",
    "karma-junit-reporter": "^2.0.1",
    "lint-staged": "^13.0.0",
    "monaco-editor": "^0.44.0",
    "playwright-ctrf-json-reporter": "^0.0.18",
    "playwright-slack-report": "^1.1.100",
    "prettier": "2.8.0",
    "ts-node": "^10.9.1",
    "typescript": "^5.4.5"
  }
}
